export enum SSOEntityId {
  EMW = 1,
  EasyBill = 3,
}
